import React from 'react'
import { Route, Switch } from 'react-router-dom'

import Page from './components/Page'

const App = () => (
  <Switch>
    <Route
      path='*'
      exact
      render={(location) => (
        <Page location={location} />
      )} />
  </Switch>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js